import { DELETEKEYRESULT_SUCCESS, DELETEKEYRESULT_FAIL } from "../actionTypes";

const initialState = {
    user: null,
};

const deleteKeyResultReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETEKEYRESULT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DELETEKEYRESULT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default deleteKeyResultReducer;
